import React, { useState, useEffect } from "react";
import Input from "../input";
import { useForm } from "react-hook-form";
import { Modal } from "antd";
import Button from "../button";
import Icon from "../../assets/icons";
import { showToast } from "../toast";
import { RingLoader } from "react-spinners";
import useApi from "../hooks/request";
import { Controller } from "react-hook-form";
import useRequest from "../hooks/use-request";
import MultiFIlterSelect from "../multi-filter-select";
import FIlterSelect from "../filter-select";

interface AddRegionDialogProps {
  isVisible: boolean;
  onClose: () => void;
  regions?: any;
}
const AddRegionDialog: React.FC<AddRegionDialogProps> = ({
  isVisible,
  onClose,
  regions,
}) => {
  const {
    control,
    setValue,
    handleSubmit,
    trigger,
    clearErrors,
    formState: { errors },
  } = useForm({
    mode: "onChange",
  });
  const [roles, setRoles] = useState<
    { _id: string; username: string; role: string }[]
  >([]);
  const { loading, makeRequest } = useApi("/region", "POST");
  const { makeRequest: getUsers } = useRequest("/users", "GET");

  const allStates = [
    { value: "abia", label: "Abia" },
    { value: "adamawa", label: "Adamawa" },
    { value: "akwa-ibom", label: "Akwa Ibom" },
    { value: "anambra", label: "Anambra" },
    { value: "bauchi", label: "Bauchi" },
    { value: "bayelsa", label: "Bayelsa" },
    { value: "benue", label: "Benue" },
    { value: "borno", label: "Borno" },
    { value: "cross-river", label: "Cross River" },
    { value: "delta", label: "Delta" },
    { value: "ebonyi", label: "Ebonyi" },
    { value: "edo", label: "Edo" },
    { value: "ekiti", label: "Ekiti" },
    { value: "enugu", label: "Enugu" },
    { value: "gombe", label: "Gombe" },
    { value: "imo", label: "Imo" },
    { value: "jigawa", label: "Jigawa" },
    { value: "kaduna", label: "Kaduna" },
    { value: "kano", label: "Kano" },
    { value: "katsina", label: "Katsina" },
    { value: "kebbi", label: "Kebbi" },
    { value: "kogi", label: "Kogi" },
    { value: "kwara", label: "Kwara" },
    { value: "lagos", label: "Lagos" },
    { value: "nasarawa", label: "Nasarawa" },
    { value: "niger", label: "Niger" },
    { value: "ogun", label: "Ogun" },
    { value: "ondo", label: "Ondo" },
    { value: "osun", label: "Osun" },
    { value: "oyo", label: "Oyo" },
    { value: "plateau", label: "Plateau" },
    { value: "rivers", label: "Rivers" },
    { value: "sokoto", label: "Sokoto" },
    { value: "taraba", label: "Taraba" },
    { value: "yobe", label: "Yobe" },
    { value: "zamfara", label: "Zamfara" },
    { value: "abuja", label: "Abuja (FCT)" },
  ];

  useEffect(() => {
    const fetchSuppliers = async () => {
      const [response] = await getUsers();
      if (response.status) {
        setRoles(response.data?.users);
      }
    };
    fetchSuppliers();
  }, []);

  const handleCreateRegion = handleSubmit(async (formData) => {
    const regions = {
      regionName: formData.regionName,
      sourcingOfficers: formData.sourcingOfficers,
      sourcingState: formData.state
    };


    const [response] = await makeRequest(regions);
    if (response.status) {
      showToast(response.message, true, { position: "top-right" });
      onClose();
      window.location.reload();
    } else {
      showToast(response?.message, false, { position: "top-right" });
    }
  });

  const renderContent = () => {
    return (
      <div className="flex flex-col gap-5">
        <Controller
          name="regionName"
          defaultValue={regions?.regionName}
          control={control}
          rules={{
            required: "Region name is required",
          }}
          render={({ field, fieldState }) => (
            <Input
              value={field.value}
              className="w-full"
              label="Region Name"
              placeholder="Enter Region Name"
              error={fieldState?.error?.message}
              onChange={field.onChange}
            />
          )}
        />

        <Controller
          name="sourcingOfficers"
          defaultValue={regions?.sourcingOfficers || []} // Ensure it's an array for multiple selections
          control={control}
          render={({ field }) => (
            <MultiFIlterSelect
              name="sourcingOfficers"
              options={roles
                .filter((role) => role.role === "sourcing-officer") // Filter roles by sourcing-officer
                .map((role) => ({
                  value: role._id, // Or whatever field in your role object represents the value
                  label: role.username,
                }))}
              className="w-full"
              label="Sourcing Officer(s)"
              placeholder="Select Sourcing Officer"
              onChange={(selectedValues) => {
                // Convert the selected values to the format required
                const selectedOfficers = selectedValues.map((id) => ({
                  _id: id,
                }));
                field.onChange(selectedOfficers); // Send data in the desired format
              }}
              value={field.value.map((officer: { _id: string }) => officer._id)}
            />
          )}
        />



        <Controller
          name="state"
          control={control}
          render={({ field }) => (
            <FIlterSelect
              name="state"
              options={allStates}
              className="w-full"
              label="Sourcing Officer(s) State"
              placeholder="Select Sourcing Region State"
              onChange={(selectedValue) => {
                field.onChange(selectedValue);
              }}
              value={field.value}
            />
          )}
        />
      </div>
    );
  };

  const renderFooterButton = () => {
    return (
      <div className="flex gap-3 py-2 mt-4">
        <Button
          type="button"
          variant="primary"
          size="lg"
          className="hover:bg-green-700 text-white flex items-center"
          onClick={handleCreateRegion}
        >
          {loading ? (
            <RingLoader color="#ffffff" loading={loading} size={20} />
          ) : (
            <div className="flex gap-3">
              <Icon name="noteIcon" /> Add Sourcing Region
            </div>
          )}
        </Button>
      </div>
    );
  };

  return (
    <Modal
      visible={isVisible}
      onCancel={onClose}
       width="80%"
        centered={true}
        footer={null}
        style={{
          padding: 0,
          margin: 0,
          maxWidth: "1200px",
          height: "auto",
        }}
    >
      <h1 className="text-2xl font-bold -mt-2 mb-4">Add Sourcing Region</h1>

      <form onSubmit={handleCreateRegion}>
        <div className="grid gap-4">{renderContent()}</div>
        {renderFooterButton()}
      </form>
    </Modal>
  );
};

export default AddRegionDialog;
